function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAbgelehnt = function SvgIconAbgelehnt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 112.51 112.51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-903.89 -483.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M963.75,483.12h52.65a0,0,0,0,1,0,0v58.51a54,54,0,0,1-54,54h-5.86A52.65,52.65,0,0,1,903.89,543v0a59.86,59.86,0,0,1,59.86-59.86Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.86,0h52.65a0,0,0,0,1,0,0V58.51a54,54,0,0,1-54,54H52.65A52.65,52.65,0,0,1,0,59.86v0A59.86,59.86,0,0,1,59.86,0Z",
    style: {
      fill: "#dfeafc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.15,497.4A43.62,43.62,0,1,1,916.53,541a43.63,43.63,0,0,1,43.62-43.62Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.4,
    y: 536.27,
    width: 88.55,
    height: 10,
    transform: "translate(-240.07 -1003.18) rotate(45)",
    style: {
      fill: "#dfeafc"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAbgelehnt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Abgelehnt.a1772578.svg";
export { ForwardRef as ReactComponent };